export enum AppPlanNames {
  HANDBOOK_FREE = 'FREE',
  HANDBOOK_PRO = 'PRO',
  TEST_PLAN = 'Test plan',
}
